<template>
  <div>
    <v-form @submit.prevent v-model="valid">
      <v-file-input
        v-model="privateKey"
        label="Chave Privada"
        required
        outlined
        placeholder="Inter API_Chave.key"
        accept=".key"
      />

      <v-file-input
        v-model="certificate"
        label="Certificado"
        required
        outlined
        placeholder="Inter API_Certificado.crt"
        accept=".crt"
      />

      <v-text-field
        v-model="clientId"
        label="ID do Cliente"
        required
        outlined
        placeholder="ID do Cliente"
        hint="ClientId"
        :rules="[(v) => uuidRegex.test(v) || 'ID do Cliente inválido']"
      />

      <v-text-field
        v-model="clientSecret"
        label="Chave Secreta"
        required
        outlined
        placeholder="Chave Secreta"
        hint="ClientSecret"
        :rules="[(v) => uuidRegex.test(v) || 'Chave Secreta inválida']"
      />

      <v-text-field
        v-model="pixKey"
        label="Chave PIX"
        required
        outlined
        placeholder="Chave PIX"
        hint="CNPJ, e-mail, telefone ou chave aleatória"
      />

      <template v-if="expirationDate">
        <v-alert v-if="isExpired" type="error" text>
          Certificado expirado, atualize o certificado para continuar usando o
          Inter
        </v-alert>
        <v-alert v-else-if="isExpiring" type="warning" text>
          Certificado válido até {{ expirationDate | date("DD/MM/YYYY") }},
          recomendamos atualizar o certificado para continuar usando o Inter
        </v-alert>
        <v-alert v-else type="success" text>
          Certificado válido até {{ expirationDate | date("DD/MM/YYYY") }}
        </v-alert>
      </template>
      <v-alert v-if="error" type="error" text>
        {{ error }}
      </v-alert>

      <v-alert type="info" text>
        Os dados serão verificados automaticamente após salvar.
        <br />
        O webhook será configurado para receber as notificações de pagamento,
        caso ele esteja configurado em outro sistema, ele será sobrescrito.
      </v-alert>

      <v-btn
        color="primary"
        @click="save"
        :disabled="!valid"
        :loading="loading"
      >
        Salvar
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import forge from "node-forge";
import moment from "moment";
import platformService from "@/services/admin/platform";

export default {
  name: "PagseguroSettings",
  props: {
    platform: {
      type: Object,
      required: true,
    },
    gateways: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      error: null,
      valid: false,
      loading: false,
      privateKey: null,
      certificate: null,
      clientId: "",
      clientSecret: "",
      pixKey: "",
      uuidRegex:
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/,
      expirationDate: null,
    };
  },
  methods: {
    async save() {
      try {
        this.loading = true;
        this.error = null;

        const privateKey = await this.fileToText(this.privateKey);
        const certificate = await this.fileToText(this.certificate);

        const response = await platformService.updateGateway(
          this.platform.id,
          "inter",
          {
            privateKey: privateKey,
            certificate: certificate,
            clientId: this.clientId,
            clientSecret: this.clientSecret,
            pixKey: this.pixKey,
          }
        );

        const publicKey = response.data.find(
          (item) => item.key === "publicKey"
        );
        if (publicKey) this.publicKey = publicKey.value;

        this.$emit("update:valid", true);
      } catch (error) {
        this.error = error.message || "Erro ao salvar configurações";
        this.$emit("update:valid", false);
      } finally {
        this.loading = false;
      }
    },
    fileToText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error("Erro ao ler arquivo"));
        reader.readAsText(file);
      });
    },
    load() {
      if (this.gateways.inter) {
        this.privateKey = new File(
          [this.gateways.inter.privateKey],
          "Inter API_Chave.key",
          {
            type: "application/octet-stream",
          }
        );
        this.certificate = new File(
          [this.gateways.inter.certificate],
          "Inter API_Certificado.crt",
          {
            type: "application/octet-stream",
          }
        );
        this.clientId = this.gateways.inter.clientId;
        this.clientSecret = this.gateways.inter.clientSecret;
        this.pixKey = this.gateways.inter.pixKey;

        // get certificate expiration date
        const cert = forge.pki.certificateFromPem(
          this.gateways.inter.certificate
        );
        const expirationDate = cert.validity.notAfter;
        this.expirationDate = expirationDate;
        console.log(this.gateways.inter);
        this.$emit("update:valid", true);
      }
    },
  },
  computed: {
    isExpired() {
      if (!this.expirationDate) return false;
      return moment(this.expirationDate).isBefore(moment());
    },
    isExpiring() {
      if (!this.expirationDate) return false;
      return moment(this.expirationDate).isBefore(moment().add(3, "month"));
    },
  },
  watch: {
    token: {
      handler(val, oldVal) {
        if (!oldVal) return;
        this.publicKey = "";
        this.$emit("update:valid", false);
      },
    },
    gateways: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  mounted() {
    this.load();
  },
};
</script>
